<template>
  <div class="c-app">
    <PublicidadInicial/>
    <AnuncioPremium/>
    <MensajeInicial/>
    <CWrapper>
      <TheHeader/>
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid style="height:100% !important">
            <transition name="fade" mode="out-in">
              <router-view :key="$route.path"></router-view>
            </transition>
          </CContainer>
        </main>
      </div>
      <TheFooter/>
    </CWrapper>
  </div>
</template>

<script>
import TheHeader from './TheHeader'
import TheFooter from './TheFooter'
import AnuncioPremium from '../components/AnuncioPremium'
import MensajeInicial from '../components/MensajeInicial'
import PublicidadInicial from '../components/PublicidadInicial'

export default {
  name: 'TheContainer',
  components: {
    TheHeader,
    TheFooter,
    AnuncioPremium,
    MensajeInicial,
    PublicidadInicial,
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.c-main {
    padding-top: 1rem;
}
</style>
